import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

//MUI
import { useTheme } from '@mui/material/styles';
import { IconButton, Box, Divider, Drawer, Grid, List, ListItem, ListItemText, ListSubheader, Paper, TextField, FormControl, Typography, } from '@mui/material';
import ListItemIcon from "@mui/material/ListItemIcon";

// MUI Icon
import SearchIcon from '@mui/icons-material/Search';
import CheckIcon from '@mui/icons-material/Check';
import DataUsageIcon from '@mui/icons-material/DataUsage';
import RemoveIcon from '@mui/icons-material/Remove';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import DevicesIcon from '@mui/icons-material/Devices';                          // Machine
import SyncAltIcon from '@mui/icons-material/SyncAlt';                          // Transaction
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';                  // Cash Status
import KeyboardCommandKeyIcon from '@mui/icons-material/KeyboardCommandKey';    // Operating
import SettingsIcon from '@mui/icons-material/Settings';                        // System
import AdjustIcon from '@mui/icons-material/Adjust';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

// API
import { fni18n } from "../../services/commonService";
import { getAPI } from "../../services/commonService";
import { API, DASH_INFO } from "../../config";
import AuthenticationService from "../../pages/auth/AuthenticationService";

import {useAtom} from "jotai"
import menuAtom from "../../utils/reducer/menuAtom";

import logo from "../../assets/images/logo/ezcams_white.png";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  logo: {
    maxWidth: 110,
    marginRight: "15px",
  },
});

//메인화면 사이드바
const MainSidebar = ({ drawerOpen, drawerToggle, window }) => {
    const classes = useStyles();

    const [menuList, setMenuList] = useState([]); //메뉴정보
    const [searhVal, setSearchVal] = useState('');

    const isUserId = AuthenticationService.getLoggedInUserID();
    const isBranchCd = AuthenticationService.getLoggedInUserBranchCd();
  
  
    const history = useHistory();

    const theme = useTheme();

    const [ menu, setMenu ] = useAtom(menuAtom)

    //화면 로드 시
    useEffect(() => {
      try {
        loadMenu();
      } catch (e) {
        console.log(e);
      }
    }, [menu]);

    const loadMenu = async () => {
      try {
        let param = {
          userId:  isUserId,
          branchCd:  isBranchCd,
        };
        await getAPI(API.COMMON.MENU, param)
        .then((res) => {
          setMenuList(res.data.result)
        }
      )
        .catch((err) => {
          console.log(err)
        });
      } catch (e) {
        console.log(e)
      }
    }

    // 페이지 이동
    const fnMove = (obj) => {  
      history.push(`${obj}`);
    }; 

    //메뉴 검색 핸들러
    const handleChange = (e) => {
      const {value} = e.target;
      setSearchVal(value);
      // setMenu(item => ({...item, selected: null, loaded: false}))
    }

    const handleListItemClick = (e, menu) => {
      e.preventDefault();
      setMenu( item => ({...item, marked: menu.appCd, selected: menu.m4}) )
    };
    
    const clickLogo = () => {
      setMenu(item => ({...item, selected: DASH_INFO.P_PAGE_NO, marked: DASH_INFO.PAGE_NO, opened: false, }))
      history.push(DASH_INFO.PAGE_URL);
    }
    const drawer = (
      <>
      {/* <LogoSection /> */}
      <Box sx={{bgcolor:theme.custom.appbarBgColor, minHeight: "100%",minWidth:"250px"}}>
        <Paper
            variant="elevation"
            elevation={0}
            square 
            sx={{
            borderRadius: '0 40px 40px 0',
            color: theme.custom.drawerTextDefaultColor,
            bgcolor: theme.custom.drawerBgColor,
            width: theme.custom.drawerWidth,
            minHeight: "100%",
            minWidth:"250px",
            }}
        >
          {/* Logo */}
          <Box sx={{ display: { xs: 'block', },}}>
            <IconButton style={theme.link.logo} onClick={clickLogo} sx={{ml: "20px",mt:"20px",mb:"10px",width:190,height:40}}>
                <img src={logo} alt="" className={classes.logo}/>
            </IconButton>
          </Box>

          <List
            sx={{
            width: "210px",
            maxWidth: 360,
            bgcolor: theme.custom.drawerBgColor,
            ml: "20px",mt:"20px"
            }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            subheader={
              <ListSubheader
                  component="div"
                  id="nested-list-subheader"
                  style={{
                    fontSize: 13,
                    textAlign: "center",
                    backgroundColor: theme.custom.drawerBgColor,
                    color: theme.custom.drawerTextDefaultColor,
                  }}
              >
              </ListSubheader>
            }
            >

            { 
              menuList
              .filter(obj => obj.m4 == null && obj.m8 !== '0')
              .map((obj) => (
              <div key={ obj.appCd }>
                  <ListItem disablePadding sx={{mt:"5px"}}>
                      {
                        obj.appCd === '0000' ? <DevicesIcon sx={{mr: 1,color: theme.custom.drawerTextDefaultColor}}/> :
                        obj.appCd === "1000" ? <SyncAltIcon sx={{mr: 1,color: theme.custom.drawerTextDefaultColor}}/> :
                        obj.appCd === "2000" ? <AttachMoneyIcon sx={{mr: 1,color: theme.custom.drawerTextDefaultColor}}/> :
                        obj.appCd === "3000" ? <KeyboardCommandKeyIcon sx={{mr: 1,color: theme.custom.drawerTextDefaultColor}}/> :
                        obj.appCd === "4000" ? <SettingsIcon sx={{mr: 1,color: theme.custom.drawerTextDefaultColor}}/> :
                        null
                      }
                    <ListItemText
                      primary={ obj.m4 === null ? fni18n(`${obj.m3}`): null }
                      disableTypography
                      style={{ fontSize: 20, color: theme.custom.drawerTextDefaultColor }}
                      // color: menu.selected && obj.appCd === menu.selected? theme.palette.primary.main: theme.palette.background.default, 
                    />
                  </ListItem>
                <div>
                  { 
                  menuList
                  .filter(obj2 => obj2.m4 !== null && obj.appCd === obj2.m4 && obj2.m8 !== '0')
                  .map((obj2) => (
                    <div key={ obj2.appCd }>
                        <List disablePadding>
                          <ListItem
                            disablePadding
                            button
                            onClick={(e) => {
                              fnMove(obj2.m1);
                              handleListItemClick(e, obj2);
                            }}
                          >
                            <Grid container>
                              <Grid item xs={10}>
                                <ListItem disablePadding 
                                  sx={{
                                    // backgroundColor:"#1b1b1b",
                                    width:210,
                                    height:30,
                                    borderRadius:"10px",
                                    color: theme.custom.drawerTextDefaultColor,
                                    backgroundColor: menu.marked && menu.marked === obj2.appCd? "#1b1b1b": "none",
                                    pb:"10px",pt:"10px"
                                  }}>
                                  <AdjustIcon fontSize='9' sx={{ml:"10px",mr:"5px",color: menu.marked && menu.marked === obj2.appCd? "#F1CF88": "#747474",}}/>
                                  <ListItemText disableTypography primary={ fni18n(`${obj2.m3}`) } style={{ fontSize: 14, }} />
                                  <KeyboardArrowRightIcon/>
                                </ListItem>
                              </Grid>
                            </Grid>
                          </ListItem>
                        </List>
                      </div>
                    ))}
                </div>
              </div>
            ))}
          </List>
          {/* <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            minHeight:"10%",
            mt: "10%",
          }}
          >
          <Typography variant="caption" sx={{ ml: 'auto', flex: 1, }}>
            COPYRIGHT Ⓒ 2023 ATEC AP. <br/>ALL RIGHTS RESERVED. <br/>(V.1.0.0)
          </Typography>
        </Box> */}
        </Paper>
        </Box>
      </>
    );
    
    const container = window !== undefined ? () => window.document.body : undefined;
    
    return(
        <Box component="nav" sx={{ flexShrink: { md: 0 }, width: theme.custom.drawerWidth }} aria-label="mailbox folders">
            <Drawer
                container={container}
                variant='persistent'
                anchor='left'
                open={drawerOpen}
                onClose={drawerToggle}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: theme.custom.drawerWidth,
                        background: theme.palette.background.default,
                        color: theme.palette.text.primary,
                        borderRight: 'none',
                        [theme.breakpoints.up('md')]: {
                            top: '0px'//64
                        }
                    }
                }}
                ModalProps={{ keepMounted: true }}
                color="inherit"
            >
                {drawer}
            </Drawer>
        </Box>
    );
}

export default MainSidebar;
